import classNames from "classnames";
import React from "react";

const Section = (props) => {
  const { children, className } = props;
  return (
    <section
      className={classNames("mx-auto max-w-screen-lg	px-5 sm:px-6", className)}
    >
      {children}
    </section>
  );
};

export default Section;
